import React from 'react';
import styled from 'styled-components';

import FaceBookIcon from '../../assets/facebook.svg';
import GitHubIcon from '../../assets/github.svg';
import InstagramIcon from '../../assets/instagram.svg';
import LinkedInIcon from '../../assets/linkedin.svg';
import MailIcon from '../../assets/mail.svg';
import TwitterIcon from '../../assets/twitter.svg';
import XingIcon from '../../assets/xing.svg';
import CodesandboxIcon from '../../assets/codesandbox.svg';

const StyledLink = styled.a`
  width: var(--icon-button-size);
  height: var(--icon-button-size);

  padding: var(--spacer);

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 1rem;

  background-color: rgb(var(--bg-primary), 0);
  border-radius: var(--border-radius);
  border: var(--glass-border);
  backdrop-filter: var(--glass-filter);
  cursor: pointer;

  box-shadow: 0 0 32px 0 rgba(255, 255, 255, 0);

  transition:
      background-color 250ms ease-in-out,
      box-shadow 250ms ease-in-out;

  &:hover {
      background-color: var(--glass-bg-hover);
      box-shadow: var(--glass-glow-hover);
  }

  svg {
      width: 100%;
      max-width: 2rem;
      max-height: 2rem;
      width: 2rem;
      height: 2rem;
  }
`;

const StyledLinks = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(--spacer-small);
  width: 100%;
`;

export function FaceBook() {
  return (
    <StyledLink
      target="_blank"
      href="https://www.facebook.com/Kollatschny"
      rel="noreferrer noopener"
      name="Facebook"
    >
      <FaceBookIcon role="img" />
    </StyledLink>
  );
}

export function Github() {
  return (
    <StyledLink
      href="https://github.com/RomanKol"
      target="_blank"
      rel="noreferrer noopener"
      name="Github"
    >
      <GitHubIcon role="img" />
    </StyledLink>
  );
}

export function Instagram() {
  return (
    <StyledLink
      href="https://www.instagram.com/romschny/"
      target="_blank"
      rel="noreferrer noopener"
      name="Instagram"
    >
      <InstagramIcon role="img" />
    </StyledLink>
  );
}

export function LinkedIn() {
  return (
    <StyledLink
      href="https://www.linkedin.com/in/romankollatschny/"
      target="_blank"
      rel="noreferrer noopener"
      name="LinkedIn"
    >
      <LinkedInIcon role="img" />
    </StyledLink>
  );
}

export function Mail() {
  return (
    <StyledLink
      href="mailto:mail@kollatschny.net"
      target="_blank"
      rel="noreferrer noopener"
      name="Mail"
    >
      <MailIcon role="img" />
    </StyledLink>
  );
}

export function Twitter() {
  return (
    <StyledLink
      href="https://twitter.com/Romschny"
      target="_blank"
      rel="noreferrer noopener"
      name="Twitter"
    >
      <TwitterIcon role="img" />
    </StyledLink>
  );
}

export function Xing() {
  return (
    <StyledLink
      href="https://www.xing.com/profile/Roman_Kollatschny"
      target="_blank"
      rel="noreferrer noopener"
      name="Xing"
    >
      <XingIcon role="img" />
    </StyledLink>
  );
}

export function Codesandbox() {
  return (
    <StyledLink
      href="https://codesandbox.io/u/RomanKol"
      target="_blank"
      rel="noreferrer noopener"
      name="Codesandbox"
    >
      <CodesandboxIcon role="img" />
    </StyledLink>
  );
}

export default function SocialButtons({ className }) {
  return (
    <StyledLinks className={className}>
      <Mail />
      <Twitter />
      <LinkedIn />
      <Xing />
      <Github />
      <Codesandbox />
      <Instagram />
      <FaceBook />
    </StyledLinks>
  );
}
